// /**
//  * @author: Pooja Vaishnav
//  */
// import React, { useEffect, useState } from "react";
// import { Button, Col, Form, Row, Table, Modal } from "react-bootstrap";
// import { useNavigate, Link } from "react-router-dom";
// import schoolApi from "../../api/schoolApi";
// import {
//   DatatableWrapper,
//   Filter,
//   Pagination,
//   PaginationOptions,
//   TableBody,
//   TableHeader,
// } from "react-bs-datatable";
// import { Helmet } from "react-helmet"; //added by muskan khan

// import InfoPill from "../InfoPill";
// import Confirm from "../Confirm";
// import { ShimmerTable } from "react-shimmer-effects";
// import { ToastContainer, toast } from "react-toastify";
// const TimeSlotList = (props) => {
//   let [sessions, setSessions] = useState([]);
//   const [modalShow, setModalShow] = useState(false);
//   const [show, setShow] = useState(false);
//   const navigate = useNavigate();
//   const [body, setBody] = useState([]);
//   const [timeslot, setTimeSlot] = useState([]);
//   const [optionTimeSlot, setOptionTimeSlot] = useState([]);
//   const [buttonName, setButtonName] = useState("Add Time Slot");

//   useEffect(() => {
//     fetchTimeSlots();
//   }, []);

//   const fetchTimeSlots = async () => {
//     try {
//       sessions = await schoolApi.fetchSessions(true);
     
//       if (sessions.success) {
//         setSessions(sessions?.result);
//       } else {
//         setSessions([]);
//       }
//       async function initTimeSlot() {
//         try {
//           const result = await schoolApi.fetchTimeSlot();

         
//           setBody(result?.result);
//           setOptionTimeSlot(result?.result);
//           setShow(false);
//         } catch (error) {
//           console.error("Error fetching timeslots:", error);
//           setBody([]);
//           setOptionTimeSlot([]);
//         }
//       }
//       initTimeSlot();
//     } catch (error) {
//       toast.error(error?.response?.data?.message);
//     }
//   };
 

//   const handleDelete = (row) => {
//     setTimeSlot(row);
//     setModalShow(true);
//    // deleteTimeSlot(row.id);
//   };

//   const handleEdit = (row) => {
//     setShow(true);
//     setTimeSlot(row);
//     setButtonName("Update");
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       await deleteTimeSlot(timeslot.id);
//       toast.success("Record deleted successfully!");
//       refresh();
//       setModalShow(false);
//     } catch (error) {
//       toast.error("Failed to delete the record.");
//     }
//   };
//   const deleteTimeSlot = async (id) => {
//     try {
     
//       const timeSlot = await schoolApi.deleteTimeSlot(id);
//       if(timeSlot.success){
//         console.log();
//       }
     
//     } catch (error) {
//       toast.error(error?.response?.data?.message);
//     }
//   };


//   const onFilterType = (event) => {
   
//     if (event.target.value === "") {
     
//       setBody(timeslot);
//     } else {
     
//       setBody(
//         optionTimeSlot.filter((data) => {
         
//           if (
//             (data.recordtype || "").toLowerCase() ===
//             (event.target.value || "").toLowerCase()
//           ) {
//             return data;
//           }
//           if (
//             (data.location || "").toLowerCase() ===
//             (event.target.value || "").toLowerCase()
//           ) {
//             return data;
//           }
//           if (
//             (data.type || "").toLowerCase() ===
//             (event.target.value || "").toLowerCase()
//           ) {
//             return data;
//           }
//         })
//       );
//     }
//   };

//   const header = [
//     { title: "Slot Type", prop: "type", isFilterable: true },
//     { title: "Start Time", prop: "start_time" },
//     { title: "End Time", prop: "end_time", isFilterable: true },
//     {
//       title: "Status",
//       prop: "status",
//       isFilterable: true,
//       cell: (row) => {

//         return row.status === "inactive" ? "Inactive" : "Active";
//       },
//     },

//     {
//       title: "Actions",
//       prop: "id",
//       cell: (row) => {
//         return (
//           <>
//             <Button
//               className="btn-sm mx-2 edit-button"
//               variant=""
//               onClick={() => handleEdit(row)}
//             >
//               <i className="fa-regular fa-pen-to-square"></i>
//             </Button>
//             <Button
//               className="btn btn-sm btn-danger mx-2"
//               variant=""
//               onClick={() => handleDelete(row)}
//             >
//               <i className="fa fa-trash"></i>
//             </Button>
//           </>
//         );
//       },
//     },
//   ];

//   const labels = {
//     beforeSelect: " ",
//   };


//   const addTimeSlot = () => {
//     setShow(true);
//   };

//   const handleChange = async (e) => {
//     setTimeSlot({ ...timeslot, [e.target.name]: e.target.value });
//   };
//   async function handleAddTimeSlot(e) {
//     e.preventDefault();
//     try {
//       if (
//         !timeslot.type ||
//         !timeslot.start_time ||
//         !timeslot.end_time ||
//         !timeslot.status
//       ) {
//         toast.error("Missing required fields!");
//         return;
//       }

//       if (
//         !timeslot.start_time ||
//         !timeslot.end_time ||
//         timeslot.start_time > timeslot.end_time
//       ) {
//         toast.error("End time must be greater than start time");
//         return;
//       }
//       if (timeslot.id) {
//         const timeSlot = await schoolApi.updateTimeSlot(timeslot);
       
//         toast.success(timeSlot?.message);
//         setTimeSlot({
//           ...timeslot,
//           type: "",
//           start_time: "",
//           end_time: "",
//           status: "",
//         });
//         refresh();
//         setShow(false);
//       } else {
//         const isDuplicate = optionTimeSlot.some((slot) => {
//           console.log("slot--->", slot); 
//           return (slot.start_time === timeslot.start_time || slot.end_time === timeslot.end_time) 
//           || (timeslot.start_time >=slot.start_time && timeslot.end_time<=slot.end_time)
//           || (timeslot.start_time <=slot.start_time && timeslot.end_time>=slot.end_time)
//         });

//       if (isDuplicate) {
//         toast.error("This time slot already exists.!");
//         return;
//       }

//         const currentYear = new Date().getFullYear();
//         const currentYearString = currentYear.toString();
       
//         let res = {
//           ...timeslot,
//           session_id: sessions[0].id,
//         };
       
//         const result = await schoolApi.createTimeSlot(res);
       
//         if (result.success === true) {
         
//           toast.success(result.message);
//           setTimeSlot({
//             ...timeslot,
//             type: "",
//             start_time: "",
//             end_time: "",
//             status: "",
//           });
//           refresh();
//           handleModalClose();
//         } else {
//           toast.success(result.message, { position: toast.POSITION.TOP_RIGHT });
//           setTimeSlot({
//             ...timeslot,
//             type: "",
//             start_time: "",
//             end_time: "",
//             status: "",
//           });
//         }
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message);
//     }
//   }
//   const refresh = () => {
//     fetchTimeSlots();
//     setButtonName("Add Time Slot");
//   };
//   const handleModalClose = () => {
//     setShow(false);
//     setButtonName("Add Time Slot");
//     setTimeSlot([]);
//   };
//   return (
//     <>
//       <Helmet>
//         <title>{props?.tabName}</title>
//       </Helmet>
//       <Row className="g-0">
//         {}
//         <Col lg={5} className="mx-4">
//           <Link className="nav-link" to="/">
//             Home <i className="fa-solid fa-chevron-right"></i> TimeSlot
//           </Link>
//         </Col>

//         <Col lg={12} className="px-lg-4">
//           {body ? (
//             <DatatableWrapper
//               body={body}
//               headers={header}
//               paginationOptionsProps={{
//                 initialState: {
//                   rowsPerPage: 15,
//                   options: [5, 10, 15, 20],
//                 },
//               }}
//             >
//               <Row className="mb-4">
//                 <Col
//                   xs={12}
//                   lg={3}
//                   className="d-flex flex-col justify-content-end align-items-end"
//                 >
//                   <Filter />
//                 </Col>
//                 <Col
//                   xs={12}
//                   sm={5}
//                   lg={5}
//                   className="d-flex flex-col justify-content-start align-items-start"
//                 >
//                   {modalShow && (
//                     <Confirm
//                       show={modalShow}
//                       onHide={() => setModalShow(false)}
//                       deleteTimeSlot={() => handleConfirmDelete()} // Pass the record id to delete
//                       title="Confirm delete?"
//                       message="You are going to delete the record. Are you sure?"
//                       table="time_slot"
//                     />
//                   )}
//                   <Form.Group className="mt-4 mx-3" controlId="formBasicStatus">
//                     <Form.Select
//                       aria-label="Enter type"
//                       name="type"
//                       onChange={onFilterType}
//                     >
//                       {console.log("optionTimeSlot", optionTimeSlot)}
//                       <option value="">--Select Type--</option>
//                       {optionTimeSlot.map((cls) => (
//                         <option key={cls.id}>{cls.type}</option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                   <PaginationOptions labels={labels} />
//                   <div style={{ marginTop: "5px" }}>
//                     <InfoPill left="Total Slots" right={body.length} />
//                   </div>
//                 </Col>
//                 <Col
//                   xs={12}
//                   sm={6}
//                   lg={4}
//                   className="mb-2 d-flex flex-col justify-content-end align-items-end"
//                 >
//                   <Button
//                     className="btn add-new-button"
//                     variant="o"
//                     onClick={() => addTimeSlot(true)}
//                   >
//                     Add Time Slot
//                   </Button>
//                 </Col>
//               </Row>
//               <Table striped className="data-table">
//                 <TableHeader />
//                 <TableBody />
//               </Table>
//               <Pagination />
//             </DatatableWrapper>
//           ) : (
//             <ShimmerTable row={10} col={8} />
//           )}
//         </Col>
//         <Col lg={2}>
//           <Modal show={show} onHide={handleModalClose} className="modal-dialog-scrollable">
//             <Modal.Header closeButton>
//               <Modal.Title>
//                 {" "}
//                 {buttonName === "Update" ? "Update " : "Add "} Time Slot
//               </Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               <Form>
//                 <Row className="mx-2">
//                   <Col md={6}>
//                     <Form.Group controlId="formType">
//                       <Form.Label>Type</Form.Label>
//                       <Form.Control
//                         type="text"
//                         placeholder="Enter type"
//                         name="type"
//                         onChange={handleChange}
//                         value={timeslot.type}
//                         required
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-4">
//                     <Form.Group controlId="formStartTime">
//                       <Form.Label>Start Time</Form.Label>
//                       <Form.Control
//                         type="time"
//                         placeholder="Enter start time"
//                         name="start_time"
//                         onChange={handleChange}
//                         value={timeslot.start_time}
//                         required
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row className="mx-2">
//                   <Col md={6}>
//                     <Form.Group controlId="formEndTime">
//                       <Form.Label>End Time</Form.Label>
//                       <Form.Control
//                         type="time"
//                         placeholder="Enter end time"
//                         name="end_time"
//                         onChange={handleChange}
//                         value={timeslot.end_time}
//                         required
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group controlId="formStatus">
//                       <Form.Label>Status</Form.Label>
//                       <Form.Select
//                         required
//                         name="status"
//                         value={timeslot.status}
//                         onChange={handleChange}
//                       >
//                         <option value="">Select Status</option>
//                         <option value="active">Active</option>
//                         <option value="inactive">Inactive</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               </Form>
//             </Modal.Body>
//             <Modal.Footer>
//               <Button variant="secondary" onClick={handleModalClose}>
//                 Close
//               </Button>
//               <Button variant="primary" onClick={handleAddTimeSlot}>
//                 {buttonName}
//               </Button>
//             </Modal.Footer>
//           </Modal>
//         </Col>
//       </Row>
//       <ToastContainer
//         position="top-right"
//         autoClose={2000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="light"
//       />
//     </>
//   );
// };

// export default TimeSlotList;
/**
 * @author: Pooja Vaishnav
 */
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table, Modal } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Helmet } from "react-helmet"; //added by muskan khan

import InfoPill from "../InfoPill";
import Confirm from "../Confirm";
import { ShimmerTable } from "react-shimmer-effects";
import { ToastContainer, toast } from "react-toastify";
const TimeSlotList = (props) => {
  let [sessions, setSessions] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [timeslot, setTimeSlot] = useState([]);
  const [optionTimeSlot, setOptionTimeSlot] = useState([]);
  const [buttonName, setButtonName] = useState("Add Time Slot");

  useEffect(() => {
    fetchTimeSlots();
  }, []);

  const fetchTimeSlots = async () => {
    try {
      sessions = await schoolApi.fetchSessions(true);

      if (sessions.success) {
        setSessions(sessions?.result);
      } else {
        setSessions([]);
      }
      async function initTimeSlot() {
        try {
          const result = await schoolApi.fetchTimeSlot();

          setBody(result?.result);
          setOptionTimeSlot(result?.result);
          setShow(false);
        } catch (error) {
          console.error("Error fetching timeslots:", error);
          setBody([]);
          setOptionTimeSlot([]);
        }
      }
      initTimeSlot();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleDelete = (row) => {
    setTimeSlot(row);
    setModalShow(true);
    // deleteTimeSlot(row.id);
  };

  const handleEdit = (row) => {
    setShow(true);
    setTimeSlot(row);
    setButtonName("Update");
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteTimeSlot(timeslot.id);
      toast.success("Record deleted successfully!");
      refresh();
      setModalShow(false);
    } catch (error) {
      toast.error("Failed to delete the record.");
    }
  };
  const deleteTimeSlot = async (id) => {
    try {
      const timeSlot = await schoolApi.deleteTimeSlot(id);
      if (timeSlot.success) {
        console.log();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const onFilterType = (event) => {
    if (event.target.value === "") {
      setBody(timeslot);
    } else {
      setBody(
        optionTimeSlot.filter((data) => {
          if (
            (data.recordtype || "").toLowerCase() ===
            (event.target.value || "").toLowerCase()
          ) {
            return data;
          }
          if (
            (data.location || "").toLowerCase() ===
            (event.target.value || "").toLowerCase()
          ) {
            return data;
          }
          if (
            (data.type || "").toLowerCase() ===
            (event.target.value || "").toLowerCase()
          ) {
            return data;
          }
        })
      );
    }
  };

  const header = [
    { title: "Slot Type", prop: "type", isFilterable: true },
    { title: "Start Time", prop: "start_time" },
    { title: "End Time", prop: "end_time", isFilterable: true },
    {
      title: "Status",
      prop: "status",
      isFilterable: true,
      cell: (row) => {
        return row.status === "inactive" ? "Inactive" : "Active";
      },
    },

    {
      title: "Actions",
      prop: "id",
      cell: (row) => {
        return (
          <>
            <Button
              className="btn-sm mx-2 edit-button"
              variant=""
              onClick={() => handleEdit(row)}
            >
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
            <Button
              className="btn btn-sm btn-danger mx-2"
              variant=""
              onClick={() => handleDelete(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </>
        );
      },
    },
  ];

  const labels = {
    beforeSelect: " ",
  };

  const addTimeSlot = () => {
    setShow(true);
    setTimeSlot({
      ...timeslot,
      type: "",
      start_time: "",
      end_time: "",
      status: "",
    });
  };

  const handleChange = async (e) => {
    setTimeSlot({ ...timeslot, [e.target.name]: e.target.value });
  };
  const toTitleCase = (str) => {
    return str
      .toLowerCase() // Convert the entire string to lowercase first
      .replace(/^([a-z])/, (match) => match.toUpperCase()) // Capitalize the first character
      .replace(/^break(\d+)$/i, (match, p1) => `Break${p1}`); // Ensure "break" is capitalized with its number part
  };
  

  async function handleAddTimeSlot(e) {
    e.preventDefault();
    try {
      //console.log('tiesghaj=>',timeSlot)
      // for (let i = 0; i < optionTimeSlot.length; i++) {
      //   const slot = optionTimeSlot[i];
      //   console.log("timeSlot@@+>", slot);

      //   if (
      //     slot.type.toLowerCase() === timeslot.type.toLowerCase() &&
      //     buttonName === "Add Time Slot"
      //   ) {
      //     console.log("78346289698");
      //     toast.error("This record is already exists with this type!");
      //     return; // Return early to stop further execution
      //   }
      // }

      if (
        !timeslot.type ||
        !timeslot.start_time ||
        !timeslot.end_time ||
        !timeslot.status
      ) {
        toast.error("Missing required fields!");
        return;
      }

      if (
        !timeslot.start_time ||
        !timeslot.end_time ||
        timeslot.start_time > timeslot.end_time
      ) {
        toast.error("End time must be greater than start time");
        return;
      }

      // const breakStartPattern = /^break/i;
      // const validBreakPattern = /^break\d+$/i;

      // if (breakStartPattern.test(timeslot.type.toLowerCase())) {
      //   if (validBreakPattern.test(timeslot.type.toLowerCase())) {
      //   } else {
      //     toast.error(
      //       "Invalid input for break. Please enter 'break1', 'break2', etc."
      //     );
      //     return;
      //   }
      // }

      const lunchStartPattern = /^lunch/i; // Check if it starts with 'lunch'
      const validLunchPattern = /^lunch\d*$/i; // 'lunch' followed by optional digits (like lunch, lunch1, lunch2)
      timeslot.type = timeslot.type.trim();
      if (lunchStartPattern.test(timeslot.type.toLowerCase())) {
        if (validLunchPattern.test(timeslot.type.toLowerCase())) {
          // Do nothing, valid input like lunch, lunch1, lunch2
        } else {
          toast.error(
            "Invalid input for lunch. Please enter 'lunch'."
          );
          return;
        }
      }
      if (optionTimeSlot.some(slot => slot.id === timeslot?.id) && buttonName==="Add Time Slot") {
        timeslot.id = timeslot.id;
        delete timeslot.id;
      }
      
      if (timeslot?.id) {
        const timeSlot = await schoolApi.updateTimeSlot(timeslot);

        toast.success(timeSlot?.message);
        setTimeSlot({
          ...timeslot,
          type: "",
          start_time: "",
          end_time: "",
          status: "",
        });
        refresh();
        setShow(false);
      } else {
        const isDuplicate = optionTimeSlot.some((slot) => {
          console.log("slot--->", slot);
          return (
            slot.start_time === timeslot.start_time ||
            slot.end_time === timeslot.end_time ||
            (timeslot.start_time >= slot.start_time &&
              timeslot.end_time <= slot.end_time) ||
            (timeslot.start_time <= slot.start_time &&
              timeslot.end_time >= slot.end_time)
          );
        });

        if (isDuplicate) {
          toast.error("This time slot already exists.!");
          return;
        }

        const currentYear = new Date().getFullYear();
        const currentYearString = currentYear.toString();

        let res = {
          ...timeslot,
          session_id: sessions[0].id,
        };

        res.type = toTitleCase(res.type);   

        const result = await schoolApi.createTimeSlot(res);

        if (result.success === true) {
          toast.success(result.message);
          setTimeSlot({
            ...timeslot,
            type: "",
            start_time: "",
            end_time: "",
            status: "",
          });
          refresh();
          handleModalClose();
        } else {
          toast.success(result.message, { position: toast.POSITION.TOP_RIGHT });
          setTimeSlot({
            ...timeslot,
            type: "",
            start_time: "",
            end_time: "",
            status: "",
          });
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  }
  const refresh = () => {
    fetchTimeSlots();
    setButtonName("Add Time Slot");
  };
  const handleModalClose = () => {
    setShow(false);
    setButtonName("Add Time Slot");
    setTimeSlot([]);
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        {}
        <Col lg={5} className="mx-4">
          <Link className="nav-link" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Time Slot
          </Link>
        </Col>

        <Col lg={12} className="px-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={3}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={5}
                  lg={5}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  {modalShow && (
                    <Confirm
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                      deleteTimeSlot={() => handleConfirmDelete()} // Pass the record id to delete
                      title="Confirm delete?"
                      message="You are going to delete the record. Are you sure?"
                      table="time_slot"
                    />
                  )}
                  <Form.Group className="mt-4 mx-3" controlId="formBasicStatus">
                    <Form.Select
                      aria-label="Enter type"
                      name="type"
                      onChange={onFilterType}
                    >
                      {console.log("optionTimeSlot", optionTimeSlot)}
                      <option value="">--Select Type--</option>
                      {optionTimeSlot.map((cls) => (
                        <option key={cls.id}>{cls.type}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <PaginationOptions labels={labels} />
                  <div style={{ marginTop: "5px" }}>
                    <InfoPill left="Total Slots" right={body.length} />
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="mb-2 d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn add-new-button"
                    variant="o"
                    onClick={() => addTimeSlot(true)}
                  >
                    Add Time Slot
                  </Button>
                </Col>
              </Row>
              <Table striped className="data-table">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}>
          <Modal
            show={show}
            onHide={handleModalClose}
            className="modal-dialog-scrollable"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {" "}
                {buttonName === "Update" ? "Update " : "Add "} Time Slot
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row className="mx-2">
                  <Col md={6}>
                    <Form.Group controlId="formType">
                      <Form.Label>Type</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter type"
                        name="type"
                        onChange={handleChange}
                        value={timeslot.type}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-4">
                    <Form.Group controlId="formStartTime">
                      <Form.Label>Start Time</Form.Label>
                      <Form.Control
                        type="time"
                        placeholder="Enter start time"
                        name="start_time"
                        onChange={handleChange}
                        value={timeslot.start_time}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mx-2">
                  <Col md={6}>
                    <Form.Group controlId="formEndTime">
                      <Form.Label>End Time</Form.Label>
                      <Form.Control
                        type="time"
                        placeholder="Enter end time"
                        name="end_time"
                        onChange={handleChange}
                        value={timeslot.end_time}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formStatus">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        required
                        name="status"
                        value={timeslot.status}
                        onChange={handleChange}
                      >
                        <option value="">Select Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleModalClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleAddTimeSlot}>
                {buttonName}
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default TimeSlotList;